let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eeNjU")).then(() => parcelRequire('1AHuQ'));